
// using package https://www.npmjs.com/package/zxing-wasm
// This would not build with our older webpack and generaly odd setup.
// I have had to include it as an IIFE. stand alone global script and access it via the window object.


import {getWordpressUrl} from "@lib/wordpressVars";
import {delay} from "@lib/utils";

const INTERNAL_NO_BARCODE_FOUND = "{{NO_BARCODE_FOUND}}";

const readerOptions  = {
    /**
     * A set of {@link ReadInputBarcodeFormat | `ReadInputBarcodeFormat`}s that should be searched for.
     * An empty list `[]` indicates all supported formats.
     *
     * Supported values in this list are:
     * `"Aztec"`, `"Codabar"`, `"Code128"`, `"Code39"`, `"Code93"`,
     * `"DataBar"`, `"DataBarExpanded"`, `"DataMatrix"`, `"DXFilmEdge"`,
     * `"EAN-13"`, `"EAN-8"`, `"ITF"`, `"Linear-Codes"`, `"Matrix-Codes"`,
     * `"MaxiCode"`, `"MicroQRCode"`, `"PDF417"`, `"QRCode"`, `"rMQRCode"`, `"UPC-A"`, `"UPC-E"`
     *
     * @defaultValue `[]`
     */
    // formats?: ReadInputBarcodeFormat[],

    tryHarder: true,
    tryRotate: true,
    tryInvert: true,
    tryDownscale: true,
    eanAddOnSymbol: "Read", // "Ignore" "Read" "Require"
};

export const getZXingWASM = () => (window as any).ZXingWASM;

let libraryAddedToDom = false;
export const loadZXingLib = async () => {
    return new Promise<void>((resolve, reject) => {
        if(!libraryAddedToDom) {
            libraryAddedToDom = true;

            //NOTE: This is an unusual use case where we want to keep this JS file outside of the normal build so that it is not processed by webpack.
            const liburl = getWordpressUrl('/zxing-wasm_1.2.11.js');
            const script = document.createElement("script");
            script.src = liburl;
            script.async = true;
            script.onload = () => {
                const checkLib = getZXingWASM();
                console.log(checkLib ? 'ZXingWASM library loaded.' : 'The ZXIngWASM library failed to load.');
                resolve();
            };
            document.body.appendChild(script);
        } else {
            resolve();
        }
    });
};

export const readBarcode = async (imageBase64, customOptions = {}) => {
    await loadZXingLib();
    const ZXingWASM = getZXingWASM();

    if(ZXingWASM && ZXingWASM.readBarcodesFromImageFile){
        const imageFile = await fetch(imageBase64);
        const imageBlob = await imageFile.blob();
        const options = {...readerOptions, ...customOptions}
        const result = await ZXingWASM.readBarcodesFromImageFile(
            imageBlob,
            options,
        );

        if(result && result.length > 0){
            const longestBarcode = result.sort((a, b) => b.text.length - a.text.length)[0];

            //Test is there a supplimental barcode.
            if(longestBarcode.text.indexOf(" ") !== -1){
                const barcode = longestBarcode.text.replace(" ",'');
                return barcode;
            }

            //Attempt to slice some of the gap between the main EAP and the assumed Supplimental and scan again.
            let croppedBarcode :string | null = null;
            const barcodeArea = longestBarcode.position;
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");

            const img = new Image();
            img.onload = async () => {
                if(ctx){
                    canvas.width=img.width;
                    canvas.height=img.height;
                    ctx.drawImage(img,0,0);

                    /// main barcode
                    const barcodeImgBuffer = img.width/100;
                    const barcodeX = barcodeArea.topLeft.x-barcodeImgBuffer;
                    const barcodeY = barcodeArea.topLeft.y-barcodeImgBuffer;
                    const barcodeWidth = (barcodeArea.bottomRight.x+barcodeImgBuffer)-barcodeX;
                    const barcodeHeight = (barcodeArea.bottomRight.y+barcodeImgBuffer)-barcodeY;

                    //Part to slice out.
                    const gapX = barcodeX+barcodeWidth;
                    const gapWidth = barcodeWidth*0.05;

                    //Part to move left.
                    const addonX = gapX + gapWidth;
                    const addonWidth = img.width - addonX;


                    const mainBarcode = ctx.getImageData(0, 0, barcodeX+barcodeWidth, img.height);
                    const addonBarcode = ctx.getImageData(addonX, 0, addonWidth, img.height);

                    //reset canvas
                    ctx.clearRect(0, 0, img.width, img.height);
                    canvas.width=barcodeX+barcodeWidth+addonWidth;
                    canvas.height=img.height;

                    // Draw in parts.
                    ctx.putImageData(mainBarcode, 0, 0);
                    ctx.putImageData(addonBarcode, barcodeX+barcodeWidth,0);

                    //Take the new image, and try to find the barcode again.
                    canvas.toBlob(async (canvasBlob) => {
                        const retry = await ZXingWASM.readBarcodesFromImageFile(
                            canvasBlob,
                            {...options, eanAddOnSymbol: "Require"},
                        );

                        if(retry && retry.length > 0){
                            const retryBarcode = retry.sort((a, b) => b.text.length - a.text.length)[0];

                            //Test is there a supplimental barcode.
                            if(retryBarcode.text.indexOf(" ") !== -1){
                                croppedBarcode = retryBarcode.text.replace(" ",'');
                            }else{
                                croppedBarcode = INTERNAL_NO_BARCODE_FOUND;
                            }
                        }else{
                            croppedBarcode = INTERNAL_NO_BARCODE_FOUND;
                        }
                    });
                }
            };
            img.src = imageBase64;

            while(croppedBarcode === null){
                await delay(10);
            }

            if(croppedBarcode !== INTERNAL_NO_BARCODE_FOUND){
                return croppedBarcode;
            }

        }else{
            //No barcode found.
        }
    }else{
        console.log('ERROR! ZXingWASM library was not loaded. ');
        return 'ERROR! ZXingWASM library was not loaded. ';
    }

    return null;
};